import { Action } from "@ngrx/store";
import { ReduxAction } from "./../actions/redux.action";
import { PatientReg } from "app/shared/models/patient-reg.model";

export function PatientRegReducer(state: PatientReg, action: ReduxAction) {
  switch (action.type) {
    case "SET_PATIENT_REG":
      return Object.assign({}, state, action.get());

    case "CLEAR_PATIENT_REG":
    case "LOGOUT":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/reducers/patient-reg.reducer.ts